"use client";

import { PopupOddCell } from "./PopupOddCell";
import {
  cellText,
  tdBorderRightAfterThirdColumn,
  trendForHandicapOrOverUnder,
  trendForOneXTwo,
} from "./oddsPopupHelpers";
import {
  oddsDetailTableClass,
  oddsGridTableClass,
  labelCellClass,
  grayHeaderCellClass,
  tdSepRight,
} from "./oddsPopupStyles";

const COLUMN_COUNT = 10;

function tripleGroupsFromBlock(block) {
  return [block.live, block.compare, block.early];
}

function MarketLabelCell({ children }) {
  return (
    <td className={labelCellClass}>
      <p className="m-0">
        <strong>{children}</strong>
      </p>
    </td>
  );
}

function GroupHeaderRow({ periodLabel, gridLines }) {
  const sep = gridLines ? undefined : tdSepRight;
  return (
    <tr>
      <td className={labelCellClass}>{periodLabel}</td>
      <td colSpan={3} className={grayHeaderCellClass} style={sep}>
        Trực tiếp
      </td>
      <td colSpan={3} className={grayHeaderCellClass} style={sep}>
        TL
      </td>
      <td colSpan={3} className={grayHeaderCellClass}>
        Sớm
      </td>
    </tr>
  );
}

function OddsMarketRow({ rowKey, title, block, resolveTrend, gridLines }) {
  return (
    <tr>
      <MarketLabelCell>{title}</MarketLabelCell>
      {tripleGroupsFromBlock(block).flatMap((tripleValues, groupIndex) =>
        tripleValues.map((cellValue, cellIndex) => {
          const borderRight =
            !gridLines && tdBorderRightAfterThirdColumn(groupIndex, cellIndex) ? tdSepRight : undefined;
          const trend = resolveTrend(block.trends, groupIndex, cellIndex);
          return (
            <td key={`${rowKey}-${groupIndex}-${cellIndex}`} className="min-w-0" style={borderRight}>
              <PopupOddCell trend={trend}>{cellText(cellValue)}</PopupOddCell>
            </td>
          );
        }),
      )}
    </tr>
  );
}

export function OddsDetailTable({ periodLabel, hdp, ou, x12, gridLines = false }) {
  const tableExtraClass =
    periodLabel === "FT" && !gridLines ? "mb-[5px]" : periodLabel === "HT" && gridLines ? "-mt-px" : "";
  const tableClass = `${gridLines ? oddsGridTableClass : oddsDetailTableClass} ${tableExtraClass}`;

  return (
    <table
      className={tableClass}
      cellPadding="0"
      cellSpacing={0}
      border="0"
    >
      <colgroup>
        <col className="w-[3.25rem] min-w-0" />
        {Array.from({ length: COLUMN_COUNT - 1 }, (_, i) => (
          <col key={i} className="min-w-0" />
        ))}
      </colgroup>
      <tbody>
        <GroupHeaderRow periodLabel={periodLabel} gridLines={gridLines} />

        <OddsMarketRow
          rowKey="hdp"
          title="HDP"
          block={hdp}
          resolveTrend={trendForHandicapOrOverUnder}
          gridLines={gridLines}
        />
        <OddsMarketRow
          rowKey="ou"
          title="O/U"
          block={ou}
          resolveTrend={trendForHandicapOrOverUnder}
          gridLines={gridLines}
        />
        <OddsMarketRow
          rowKey="x12"
          title="1x2"
          block={x12}
          resolveTrend={trendForOneXTwo}
          gridLines={gridLines}
        />

        {gridLines ? null : (
          <tr>
            <td colSpan={COLUMN_COUNT} className="p-1" />
          </tr>
        )}
      </tbody>
    </table>
  );
}
